import {DrugsCategoryFormSchema} from '@/modules/basic-data/categories/schemas'
import {SelectItem} from '@cypro/ui/components/form/select'
import {DrugsCategory} from '@cypro/engine/schema'

export function getDefaultDrugsCategoryFormValues(category: DrugsCategory | undefined): DrugsCategoryFormSchema {
  return {
    id: category?.id,
    description: category?.description || '',
    name: category?.name || '',
    subcategories:
      category?.children?.map(child => ({
        id: child.id,
        name: child.name || '',
        description: child.description || '',
        status: child.status || 'active',
      })) || [],
    status: category?.status || 'active',
  }
}

export function mapDrugsCategoriesToSelectItems(categories: DrugsCategory[]): SelectItem[] {
  return categories.map(c => ({...c, label: c.name, value: c.id}))
}

export function isDrugsCategoryDeletable(category: DrugsCategory) {
  return !category.drugCatalogItemsCategories?.length
}
